import { useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";
import constants from "../../../Utils/constants";
import { haveValue } from "../../../helper/common";
import LandlordProgressbar from "./LandlordProgressbar";
import { trackClarityEvent } from "../../../Utils/clarityReady";
import { Button, Checkbox } from "../../../components/design";

const UserGoalsModal = ({
  progressStep,
  setCurrentStep,
  formData,
  setFormData,
}) => {
  const { _t } = useTranslator();
  const cards = [
    {
      id: constants.AUTOMATE_TENANT_SCREENING,
      img: "/images/tenant-screening-icon.svg",
      titleKey: "automateTheTenantScreening",
    },
    {
      id: constants.AVOID_FRAUD_MANIPULATION,
      img: "/images/avoid-fraud-icon.svg",
      titleKey: "avoidFraudAndManipulation",
    },
    {
      id: constants.IMPROVE_RISK_PORTFOLIO,
      img: "/images/my-portfolio-icon.svg",
      titleKey: "improveTheRiskOfMyPortfolio",
    },
    {
      id: constants.REDUCE_INSURANCE_SPEND,
      img: "/images/spend-insurance-icon.svg",
      titleKey: "reduceHowMuchISpendOnInsurance",
    },
    {
      id: constants.DONT_KNOW,
      img: "/images/user-question-icon.svg",
      titleKey: "iDontKnowYet",
    },
  ];
  const [selected, setSelected] = useState(formData.ll_use_case);

  // toggle selection
  const handleSelectCard = (id) => {
    setSelected((prev) => {
      const tempState = prev.includes(id)
        ? prev.filter((item) => item !== id) // remove
        : [...prev, id]; // add

      setFormData((prevForm) => ({ ...prevForm, ll_use_case: tempState }));
      return tempState;
    });
  };

  const handleNextStep = () => {
    trackClarityEvent("landlord_how_do_you_want_to_achieve_step_ended");
    setTimeout(() => {
      trackClarityEvent("landlord_hear_about_skor_step_started");
    }, constants.CLARITY_DELAY);
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  return (
    <div>
      <Modal
        show={true}
        // onHide={handleCloseModal}
        centered
        className="landlord-onboarding-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <h4>{_t("whichOfTheFollowingOptionsBetterDefineYou")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{_t("pleaseSelectAnOptionThatDefineYouBetter")}</p>
          <LandlordProgressbar step={progressStep + 1} />
          <div className="better-cards-goal-comp">
            {cards.map((card) => (
              <div
                onClick={() => handleSelectCard(card.id)}
                className={`usage-card ${
                  selected.includes(card.id) ? "select-card " : ""
                }`}
                key={card.id}
              >
                <span onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    checked={selected.includes(card.id)}
                    onChange={() => handleSelectCard(card.id)}
                  />
                </span>
                <img src={card.img} alt={card.id + "-icon"} />
                <h3 class="text-start">{_t(card.titleKey)}</h3>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="landlord-modal-group-btn">
            <Button variant="secondary" size="lg" onClick={handlePrevStep}>
              {_t("back")}
            </Button>
            <Button
              size="lg"
              onClick={handleNextStep}
              disabled={
                !haveValue(formData.ll_use_case) ||
                formData.ll_use_case?.length == 0
              }
            >
              {_t("next")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserGoalsModal;
